import { useAtom } from "jotai";
import { AppStateAtom } from "../../store";
import { useSettingsController } from "./useSettingsController";
import React from "react";
import {
  AccountSettings,
  DangerZone,
  PasswordChangeSheet,
  LogoutConfirmationDialog,
} from "./components";
import { purgeAllClientData } from "../../api/Users";

const SettingsComponent = () => {
  const controller = useSettingsController();
  const [appState] = useAtom(AppStateAtom);

  return (
    <div className="container py-8 max-w-4xl">
      <div className="flex flex-col space-y-8">
        <div>
          <h1 className="text-3xl font-bold mb-2">Settings</h1>
          <p className="text-muted-foreground">
            Manage your account preferences and settings
          </p>
        </div>

        {/* Account Settings Section */}
        <AccountSettings
          userEmail={appState.user?.email}
          onChangePassword={() => controller.setPasswordDrawerOpen(true)}
        />

        {/* Danger Zone Section */}
        <DangerZone onLogout={() => controller.setLogOutModalOpen(true)} />

        {/* Admin Section */}
        {appState.user?.role === "admin" && (
          <div className="rounded-lg border p-6">
            <h2 className="text-xl font-semibold mb-2">Admin</h2>
            <p className="text-muted-foreground mb-4">
              Delete all accounts, transactions, holdings, funds, and reporting periods for this tenant.
            </p>
            <button
              onClick={async () => {
                const confirmed = window.confirm(
                  "Are you sure? This permanently deletes all accounts, transactions, holdings, and funds for this tenant."
                );
                if (!confirmed) return;
                try {
                  const result = await purgeAllClientData();
                  if ((result as any).status === "ok") {
                    alert("All data deleted.\nYou may need to refresh the app.");
                  } else {
                    alert("Failed: " + JSON.stringify(result));
                  }
                } catch (e: any) {
                  alert("Error: " + e?.message ?? e);
                }
              }}
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Delete All (Admin)
            </button>
          </div>
        )}
      </div>

      {/* Password Change Sheet */}
      <PasswordChangeSheet
        open={controller.passwordDrawerOpen}
        onOpenChange={(open) => {
          if (!open) {
            controller.setPasswordDrawerOpen(false);
            controller.setPassword("");
          }
        }}
        password={controller.password}
        onPasswordChange={controller.setPassword}
        onSave={controller.changePassword}
        loading={controller.loading}
      />

      {/* Logout Confirmation Dialog */}
      <LogoutConfirmationDialog
        open={controller.logOutModalOpen}
        onOpenChange={controller.setLogOutModalOpen}
        onConfirm={controller.handleLogout}
      />
    </div>
  );
};

export const Settings = SettingsComponent;
